import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Container from '../page/Container.css';
import { useLocation } from 'react-router-dom';

function App() {
    const [blId, setBlId] = useState("");
    const [cntrId, setCntrId] = useState("");
    const [data, setData] = useState([]);

    const [cntrNo, setCntrNo] = useState('');
    const [blNumber, setBlNumber] = useState('');
    const location = useLocation();

    useEffect(() => {
        // Retrieve the CntrNo and BLNumber query parameters from the URL
        const searchParams = new URLSearchParams(location.search);
        const cntrNoParam = searchParams.get('CntrNo');
        const blNumberParam = searchParams.get('BLNumber');

        const cntridParam = searchParams.get('CntrId');
        const blidParam = searchParams.get('blid');
        fetchData(cntridParam, blidParam);

    }, [location]);


    const openFile = (filesv, isDepo) => {

        if (isDepo == 1)
            window.open('https://depo.oceanus-lines.com/MNRAttachments/' + filesv, '_blank');
        else
            window.open('https://oceanus-lines.com/MNRAttachments/' + filesv, '_blank');
    };

    const fetchData = async (Cntridv, blidv) => {

        try {
            const payload = {
                "BLID": blidv,
                "CntrID": Cntridv
            };
            const response = await axios.post('https://oceanus-lines.com/api/OnLIne/OnlineCntr_Mnr_Traking', payload, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status !== 200) {
                throw new Error('Network response was not ok');
            }

            const extractedData = response.data.map(item => ({
                MNRId: item.MNRId,
                MnrRefNo: item.MnrRefNo,
                EmptyGateIN: item.EmptyGateIN,
                CntrNo: item.CntrNo,
                MNRStatus: item.MNRStatus,
                CntrType: item.CntrType,
                Currency: item.Currency,
                Agency: item.Agency,
                Location: item.Location,
                Depot: item.Depot,
                EstAmt: item.EstAmt,
                RecoveryBreakUp: item.OnlineCntrDtls_Recovery_list,
                EstimateDate: item.EstimateDate,
                BLNumber: item.BLNumber
            }));

            setData(extractedData);

            // Set BL ID and Container ID values from the API payload
            setBlId(payload.BLID);
            setCntrId(payload.CntrID);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    return (
        <div>
            {data.map((item, index) => (
                <section key={index} className="banner-section-four">
                    <div className="auto-container">
                        <div className="cotnent-box">
                            <div className="job-search-form aos-init aos-animate" data-aos-delay="700" data-aos="fade-up">
                                <form>
                                    <div className="row">
                                        <div className="form-group col-lg-6 col-md-12 col-sm-12">
                                            <span className="icon"></span>
                                            <input type="text" name="blId" id="blId" placeholder="BL ID" value={item.BLNumber} onChange={(e) => setBlId(e.target.value)} />
                                        </div>
                                        <div className="form-group col-lg-5 col-md-12 col-sm-12">
                                            <span className="icon"></span>
                                            <input type="text" name="cntrId" id="cntrId" placeholder="Container ID" value={cntrNo} onChange={(e) => setCntrId(e.target.value)} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            ))}
      

            {data.map((item, index) => (
                <section class="job-section alternate mb-5" key={index}>
                    <div class="auto-container">
                        <div class="sec-title text-center">
                            <h2>EOR DETAILS</h2>
                        </div>
                        <div class="col-md-10 offset-md-1 pl">
                            <div class="row aos-init aos-animate" data-aos="fade-up" data-aos-anchor-placement="top-bottom">
                                <div class="category-block col-lg-4 col-md-6 col-sm-12">
                                    <div class="inner-box">
                                        <div class="content"><span class="icon"><i class="las la-plus-square"></i></span>
                                            <h4><a>EOR No</a></h4>
                                            <p>{item.MnrRefNo}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="category-block col-lg-4 col-md-6 col-sm-12">
                                    <div class="inner-box">
                                        <div class="content"><span class="icon"><i class="las la-calendar"></i></span>
                                            <h4><a>EOR Date</a></h4>
                                            <p>{item.EstimateDate}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="category-block col-lg-4 col-md-6 col-sm-12">
                                    <div class="inner-box">
                                        <div class="content"><span class="icon"><i class="las la-calendar"></i></span>
                                            <h4><a>Empty Return Date</a></h4>
                                            <p>{item.EmptyGateIN}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="category-block col-lg-4 col-md-6 col-sm-12">
                                    <div class="inner-box">
                                        <div class="content"><span class="icon"><i class="las la-keyboard"></i></span>
                                            <h4><a>Container Number</a></h4>
                                            <p>{item.CntrNo}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="category-block col-lg-4 col-md-6 col-sm-12">
                                    <div class="inner-box">
                                        <div class="content"><span class="icon"><i class="las la-crop-alt"></i></span>
                                            <h4><a>Container Size/Type</a></h4>
                                            <p>{item.CntrType}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="category-block col-lg-4 col-md-6 col-sm-12">
                                    <div class="inner-box">
                                        <div class="content"><span class="icon"><i class="las la-rupee-sign"></i></span>
                                            <h4><a>Currency</a></h4>
                                            <p>{item.Currency}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            ))}

            {data.map((item, index) => (
                <div className="container" key={index}>
                    <div className="row">
                        {/* EOR PENDING section */}
                        <div className="sec-title text-center">
                            <h2>{item.MNRStatus}</h2>
                        </div>
                        <div className="col-md-12" id='bor' style={{ textAlign: 'center' }}>
                            <table className="table table-bordered table-light table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Location</th>
                                        <th scope="col">Agency</th>
                                        <th scope="col">MNRNO</th>
                                        <th scope="col">Container NO</th>
                                        <th scope="col">Container Type</th>
                                        <th scope="col">Empty In</th>
                                        <th scope="col">Depot</th>
                                        <th scope="col">Currency</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{item.Location}</td>
                                        <td>{item.Agency}</td>
                                        <td>{item.MnrRefNo}</td>
                                        <td>{item.CntrNo}</td>
                                        <td>{item.CntrType}</td>
                                        <td>{item.EmptyGateIN}</td>
                                        <td>{item.Depot}</td>
                                        <td>{item.Currency}</td>
                                        <td>{item.EstAmt}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7"></td>
                                        <th>Total</th>
                                        <td>{item.EstAmt}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* Recovery Break-Up section */}
                        <div className="col-md-12" style={{ textAlign: 'center' }}>
                            {data.some(item => item.MNRStatus === 'MNR Complete' || item.MNRStatus === 'pending MNR') && (
                                <div>
                                    <div className="sec-title text-center mt-5">
                                        <h2>Recovery Break-Up</h2>
                                    </div>
                                    <table className="table">
                                        <thead className="table-dark">
                                            <tr>
                                                <th scope="col">S.No</th>
                                                <th scope="col">Accountability</th>
                                                <th scope="col">ItemNo</th>
                                                <th scope="col">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Render Recovery Break-Up data */}
                                            {data.map((item, index) => (
                                                item.MNRStatus === 'MNR Complete' || item.MNRStatus === 'pending MNR' ? (
                                                    item.RecoveryBreakUp.map((recoveryItem, recoveryIndex) => (
                                                        <tr key={recoveryIndex}>
                                                            <th scope="row">{recoveryIndex + 1}</th>
                                                            <td>{recoveryItem.Accountability}</td>
                                                            <td>{recoveryItem.ItemNo}</td>
                                                            <td>{recoveryItem.RecoveryAmount}</td>
                                                        </tr>
                                                    ))
                                                ) : null
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            ))}
            <div class="container mb-5">
                <div className='row'>
                    <div className='col-md-12' id='mob'>
                    <table className="table table-borderless text-center table-success">
                            <thead>
                                <tr>
                                    <th scope="col">S.No</th>
                                    <th scope="col">Attach File</th>
                                    <th scope="col">Attachment Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Map over data to render each item */}
                                {data.map((item, index) => (
                                    // Check if OnlineCntrDtls_Recovery_list exists for the item
                                    item.RecoveryBreakUp && item.RecoveryBreakUp.map((recoveryItem, recoveryIndex) => (
                                        <tr key={recoveryIndex}>
                                            <th scope="row">{recoveryIndex + 1}</th>
                                          
                                            <td>
                                                <div className="grid-item" onClick={() => openFile(recoveryItem.fileAttached)}>
                                                    {recoveryItem.fileAttached}
                                                </div>
                                            </td>
                                            <td>{recoveryItem.attachmentType}</td>
                                        </tr>
                                    ))
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
